import type {
  Account,
  APIKey,
  Billable,
  Campaign,
  Conversion,
  Creative,
  CustomField,
  DataRequest,
  Domain,
  DonationForm,
  EmailVerification,
  Event,
  Flight,
  Form,
  Importer,
  Partner,
  Person,
  Segment,
  Template,
} from '@feathr/blackbox';

export const resourceToCollectionMap = {
  account: 'Accounts',
  importer: 'Importers',
  apiKey: 'APIKeys',
  customField: 'CustomFields',
  segment: 'Segments',
  flight: 'Flights',
  creative: 'Creatives',
  template: 'Templates',
  campaign: 'Campaigns',
  person: 'Persons',
  form: 'Forms',
  donationForm: 'DonationForms',
  dataRequest: 'DataRequests',
  event: 'Events',
  conversion: 'Conversions',
  partner: 'Partners',
  domain: 'Domains',
  email: 'EmailVerifications',
  billable: 'Billables',
} as const;

export const paramKeyToCollectionMap = resourceToCollectionMap;

/**
 * Type mapping from param keys to their corresponding model types
 */
export type ModelTypeMap = {
  accountId: Account;
  billableId: Billable;
  importerId: Importer;
  customFieldId: CustomField;
  segmentId: Segment;
  flightId: Flight;
  creativeId: Creative;
  templateId: Template;
  campaignId: Campaign;
  personId: Person;
  formId: Form;
  donationFormId: DonationForm;
  dataRequestId: DataRequest;
  eventId: Event;
  conversionId: Conversion;
  partnerId: Partner;
  domainId: Domain;
  emailId: EmailVerification;
  apiKeyId: APIKey;
};

/**
 * Resource names that can be passed to useIdParams
 */
export type ResourceName = keyof typeof resourceToCollectionMap;

/**
 * Maps resource names to their corresponding param names
 * e.g., 'campaign' -> 'campaignId'
 */
export type ResourceParamName<T extends ResourceName> = `${T}Id`;
